<template>
  <div class="wrapper">
    <side-bar type="sidebar" :sidebar-links="links" :title="company ? company.name : null" :logo="company ? company.logo : null" :to="{name: 'View'}">
      <user-menu></user-menu>
      <form class="navbar-form navbar-left navbar-search-form navbar-search-form-mobile" role="search">
        <div class="input-group">
          <span class="input-group-addon"><i class="fa fa-search"></i></span>
          <input type="text" value="" class="form-control" placeholder="Search...">
        </div>
      </form>
      <mobile-menu></mobile-menu>
    </side-bar>

    <div class="main-panel">
      <top-navbar></top-navbar>
      <dashboard-content @click.native="toggleSidebar">
      </dashboard-content>

      <content-footer></content-footer>
    </div>
  </div>
</template>
<style lang="scss">

</style>
<script>
  import TopNavbar from './TopNavbar.vue'
  import ContentFooter from './ContentFooter.vue'
  import DashboardContent from './Content.vue'
  import UserMenu from 'src/components/UIComponents/SidebarPlugin/UserMenu.vue'
  import MobileMenu from 'src/components/UIComponents/SidebarPlugin/MobileMenu.vue'

  import api from '@/api'
  import { mapGetters, mapActions } from 'vuex'

  export default {
    components: {
      TopNavbar,
      ContentFooter,
      DashboardContent,
      UserMenu,
      MobileMenu
    },
    watch: {
      company (company) {
        console.log(company)
        this.fetchAllStores(company)
      },
      profile (profile) {
        console.log(profile)
      }
    },
    mounted () {
      this.fetchAllStores(this.company)
    },
    computed: {
      ...mapGetters('profiles', {
        profile: 'mine'
      }),
      ...mapGetters('companies', {
        company: 'mine'
      }),
      ...mapGetters('stores', {
        stores: 'all'
      }),
      storeLinks () {
        if (this.stores && this.stores.length > 1) {
          return {
            name: 'Boutiques',
            icon: 'ti-home',
            collapsed: true,
            children: [{
              name: 'Liste',
              to: { name: 'StoreList', params: { company: this.$route.params.company } }
            },
            {
              name: 'Statistiques',
              to: { name: 'StoreStats', params: { company: this.$route.params.company } }
            }
            ]
          }
        }
      },
      links () {
        const dashboard = {
          name: 'Tableau de bord',
          icon: 'ti-panel',
          to: { name: 'Overview', params: { company: this.$route.params.company } }
        }
        return [
          dashboard,
          this.storeLinks,
          {
            name: 'Produits',
            icon: 'ti-view-list-alt',
            collapsed: true,
            children: [{
              name: 'Liste',
              to: { name: 'ProductList', params: { company: this.$route.params.company } }
            },
            {
              name: 'Statistiques',
              to: { name: 'ProductStats', params: { company: this.$route.params.company } }
            }
            ]
          },
          {
            name: 'Commandes',
            icon: 'ti-credit-card',
            collapsed: true,
            children: [{
              name: 'Liste',
              to: { name: 'OrderList', params: { company: this.$route.params.company } }
            }]
          },
          {
            name: 'Components',
            icon: 'ti-package',
            children: [{
              name: 'Buttons',
              path: '/components/buttons'
            },
            {
              name: 'Grid System',
              path: '/components/grid-system'
            },
            {
              name: 'Panels',
              path: '/components/panels'
            },
            {
              name: 'Sweet Alert',
              path: '/components/sweet-alert'
            },
            {
              name: 'Notifications',
              path: '/components/notifications'
            },
            {
              name: 'Icons',
              path: '/components/icons'
            },
            {
              name: 'Typography',
              path: '/components/typography'
            }]
          },
          {
            name: 'Forms',
            icon: 'ti-clipboard',
            children: [{
              name: 'Regular Forms',
              path: '/forms/regular'
            },
            {
              name: 'Extended Forms',
              path: '/forms/extended'
            },
            {
              name: 'Validation Forms',
              path: '/forms/validation'
            },
            {
              name: 'Wizard',
              path: '/forms/wizard'
            }
            ]
          },
          {
            name: 'Maps',
            icon: 'ti-map',
            children: [{
              name: 'Google Maps',
              path: '/maps/google'
            },
            {
              name: 'Full Screen Maps',
              path: '/maps/full-screen'
            },
            {
              name: 'Vector Maps',
              path: '/maps/vector-map'
            }
            ]
          },
          {
            name: 'Charts',
            icon: 'ti-gift',
            path: '/charts'
          },
          {
            name: 'Calendar',
            icon: 'ti-calendar',
            path: '/calendar'
          },
          {
            name: 'Pages',
            icon: 'ti-gift',
            children: [{
              name: 'User Page',
              path: '/pages/user'
            },
            {
              name: 'Timeline Page',
              path: '/pages/timeline'
            },
            {
              name: 'Login Page',
              path: '/login'
            },
            {
              name: 'Register Page',
              path: '/register'
            },
            {
              name: 'Lock Page',
              path: '/lock'
            }
            ]
          }
        ]
      }
    },
    methods: {
      toggleSidebar () {
        if (this.$sidebar.showSidebar) {
          this.$sidebar.displaySidebar(false)
        }
      },
      ...mapActions('stores', {
        fetchAllStores: 'bind'
      })
    }
  }

</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Layout/DashboardLayout.vue